import { Head } from "@inertiajs/react";

import Layout from "/Layout";

export default function Static({
  og_title,
  og_description,
  og_image,
  content,
  content_link,
}) {
  return (
    <>
      <Layout>
        <Head>
          {og_title && (<meta head-key="og:title" key="og:title" property="og:title" content={og_title} />)}
          {og_description && (<meta head-key="og:description" key="og:description" property="og:description" content={og_description} />)}
          {og_image.type && (<meta key="og:image:type" property="og:image:type" content={og_image.type} />)}
          {og_image.url && (<meta key="og:image" property="og:image" content={og_image.url} />)}
          {og_image.url && (<meta key="og:image:width" property="og:image:width" content="1200" />)}
          {og_image.url && (<meta key="og:image:height" property="og:image:height" content="630" />)}

          {og_title && (<meta head-key="twitter:title" key="twitter:title" name="twitter:title" content={og_title} />)}
          {og_description && (<meta head-key="twitter:description" key="twitter:description" name="twitter:description" content={og_description} />)}
          {og_image.url && (<meta head-key="twitter:card" key="twitter:card" name="twitter:card" content="summary_large_image" />)}
          {og_image.type && (<meta key="twitter:image:type" name="twitter:image:type" content={og_image.type} />)}
          {og_image.url && (<meta key="twitter:image" name="twitter:image" content={og_image.url} />)}
          {og_image.url && (<meta key="twitter:image:width" name="twitter:image:width" content="1200" />)}
          {og_image.url && (<meta key="twitter:image:height" name="twitter:image:height" content="630" />)}
        </Head>

        <div className="static-container">
          {content_link ? (
            <h1 className="oneline"><a href={content_link} dangerouslySetInnerHTML={{ __html: content }} /></h1>
          ) : (
            <h1 className="oneline" dangerouslySetInnerHTML={{ __html: content }} />
          )}
        </div>
      </Layout>
    </>
  );
}
